var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "subscription-lesson-plan" },
    [
      _c("page-title", { staticClass: "subscription-lesson-plan__title" }, [
        _vm._v("\n    Unlock "),
        _c("span", [_vm._v("all ReadTheory Premium Features")]),
        _c("br"),
        _vm._v("+ the Fall Lesson Bundle.\n  "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "subscription-lesson-plan__content" },
        [
          _c("rt-picture", {
            staticClass: "subscription-lesson-plan__content-picture",
            attrs: {
              src: "/assets/app/class/lesson-bundle-bg.png",
              autosize: false,
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "subscription-lesson-plan__content-features" },
            [
              _c(
                "p",
                {
                  staticClass:
                    "subscription-lesson-plan__content-features-summary",
                },
                [
                  _vm._v(
                    "\n        This will allow you to assign specific passages including some for Fall that you can pair with the following:\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "subscription-lesson-plan__content-list" },
                _vm._l(_vm.lessonFeatures, function (feature) {
                  return _c(
                    "li",
                    { staticClass: "subscription-lesson-plan__content-item" },
                    [
                      _c("rt-picture", {
                        attrs: {
                          src: "/assets/app/class/icon-item-checkmark.svg",
                          autosize: false,
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass:
                            "subscription-lesson-plan__content-item-text",
                        },
                        [
                          _vm._v(
                            "\n            " + _vm._s(feature) + "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "primary-button",
                {
                  staticClass: "btn-choose-plan",
                  on: { click: _vm.handleChooseMyPlan },
                },
                [_vm._v("\n        Choose My Plan\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("subscription-satisfaction", {
        staticClass: "subscription-lesson-plan__satisfaction",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }